import React from 'react';
import { Redirect, Route, RouteComponentProps, Switch } from 'react-router-dom';
import { DeviceListPage } from './pages';

export const PropertyDevicesRoutes: React.FC<RouteComponentProps> = ({ match }) => {
  return (
    <Switch>
      <Route path={`${match.path}`} component={DeviceListPage} />
      <Redirect to={match.path} />
    </Switch>
  );
};
